<app-terms-policy [data]="data" [heading]="'Privacy Policy'" [updatedDate]="'June 07, 2021'">
</app-terms-policy>